export { default } from './discount-price';
